export const DEFAULT_CATEGORY_FEATURES = {
    supportsAudio: false,
    supportsVideo: false,
    supportsRichText: true,
    saveLabel: 'Save Post',
    createLabel: 'New Post',
    postType: 'article'
};

export const CATEGORY_FEATURES = {
    4: {
        supportsAudio: false,
        supportsVideo: true,
        supportsRichText: false,
        saveLabel: 'Save Video',
        createLabel: 'New Video',
        postType: 'video'
    },
    7: {
        supportsAudio: true,
        supportsVideo: false,
        supportsRichText: false,
        saveLabel: 'Save Track',
        createLabel: 'New Track',
        postType: 'audio'
    },
    8: {
        supportsAudio: false,
        supportsVideo: true,
        supportsRichText: false,
        saveLabel: 'Save Video',
        createLabel: 'New Video',
        postType: 'video'
    },
    9: {
        supportsAudio: false,
        supportsVideo: true,
        supportsRichText: false,
        saveLabel: 'Save Video',
        createLabel: 'New Video',
        postType: 'video'
    }
};

export const getCategoryFeatures = (categoryId) => {
    const normalizedCategoryId = Number(categoryId);
    return {
        ...DEFAULT_CATEGORY_FEATURES,
        ...(CATEGORY_FEATURES[normalizedCategoryId] || {})
    };
};

export const supportsAudioCategory = (categoryId) => getCategoryFeatures(categoryId).supportsAudio;
export const supportsVideoCategory = (categoryId) => getCategoryFeatures(categoryId).supportsVideo;
export const supportsRichTextCategory = (categoryId) => getCategoryFeatures(categoryId).supportsRichText;
